import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import { Row, Col } from 'react-bootstrap';
import Question from '../Question';
var getOptions = function getOptions(asyncUrl, input) {
  return axios.get(asyncUrl, {
    params: {
      term: input
    }
  }).then(function (response) {
    var compare = response.data.filter(function (i) {
      return i.text.toLowerCase().includes(input.toLowerCase());
    });
    return compare.map(function (i) {
      return {
        label: i.text,
        value: i.id
      };
    });
  });
};
var setYear = function setYear(value, yearOptions) {
  if (value == null) return '';
  var yearIndex = yearOptions.findIndex(function (x) {
    return x.value === value;
  });
  return yearOptions[yearIndex];
};
var renderQuestion = function renderQuestion(question, answers, handleInputChange, questionIndex, errors, disabled, onboardingQuestionnaire) {
  var answer = answers.find(function (a) {
    return a.question_key === question.question_key;
  });
  var value = answer.value;
  var year = new Date().getFullYear();
  var yearOptions = Array.from(new Array(75), function (val, index) {
    var newYear = year - index;
    return {
      label: newYear,
      value: newYear
    };
  });
  var dropdownStyle = onboardingQuestionnaire ? {
    IndicatorSeparator: function IndicatorSeparator() {
      return null;
    },
    DropdownIndicator: function DropdownIndicator() {
      return /*#__PURE__*/React.createElement("i", {
        className: "fas fa-angle-down"
      });
    }
  } : {};
  var classNamePrefix = errors && errors.includes(question.column_name.replace('_id', '')) ? 'select-error' : 'react-select';
  switch (question.question_type) {
    case 'select_one':
      if (question.async_url !== null) {
        return /*#__PURE__*/React.createElement(Question, {
          title: question.question_text,
          className: "".concat(question.question_type, " ").concat(question.style),
          subtext: question.subtext,
          onboardingQuestionnaire: onboardingQuestionnaire,
          questionKey: question.question_key
        }, /*#__PURE__*/React.createElement(AsyncSelect, {
          components: dropdownStyle,
          className: "asyncselect ".concat(question.question_key),
          loadOptions: function loadOptions(input) {
            return getOptions(question.async_url, input);
          },
          value: value !== null ? [value] : [],
          maxMenuHeight: 500,
          onChange: function onChange(option) {
            return handleInputChange(option, answer.column_name, questionIndex);
          },
          isDisabled: disabled,
          onSelectResetsInput: false,
          closeOnSelect: true,
          closeMenuOnSelect: true,
          classNamePrefix: "clora-multiselect",
          placeholder: "Select or type...",
          cacheOptions: true,
          defaultOptions: true
        }));
      }
      return /*#__PURE__*/React.createElement(Question, {
        title: question.question_text,
        className: "".concat(question.question_type, " ").concat(question.style),
        subtext: question.subtext,
        onboardingQuestionnaire: onboardingQuestionnaire,
        questionKey: question.question_key
      }, /*#__PURE__*/React.createElement(Select, {
        components: dropdownStyle,
        className: "".concat(question.question_type, " ").concat(question.style, " ").concat(question.question_key),
        classNamePrefix: classNamePrefix,
        placeholder: "Select or type...",
        options: question.options,
        value: value !== null ? [value] : [],
        onChange: function onChange(option) {
          return handleInputChange(option, answer.column_name, questionIndex);
        },
        isDisabled: disabled
      }));
    case 'freetext':
    case 'location':
      if (question.style === 'text_input') {
        return /*#__PURE__*/React.createElement(Question, {
          title: question.question_text,
          className: "".concat(question.question_type, " ").concat(question.style),
          subtext: question.subtext,
          onboardingQuestionnaire: onboardingQuestionnaire,
          questionKey: question.question_key
        }, /*#__PURE__*/React.createElement("div", {
          className: "input-field"
        }, /*#__PURE__*/React.createElement("input", {
          className: "input-base ".concat(question.question_key, " ").concat(disabled ? 'disabled' : ''),
          type: "text",
          value: value || '',
          onChange: function onChange(e) {
            return handleInputChange(e.target.value, answer.column_name, questionIndex);
          },
          placeholder: "Type here...",
          disabled: disabled,
          required: true
        })));
      }
      break;
    case 'number':
      if (question.style === 'number_input') {
        return /*#__PURE__*/React.createElement(Question, {
          title: question.question_text,
          className: "".concat(question.question_type, " ").concat(question.style),
          subtext: question.subtext,
          onboardingQuestionnaire: onboardingQuestionnaire,
          questionKey: question.question_key
        }, /*#__PURE__*/React.createElement("div", {
          className: "input-field"
        }, /*#__PURE__*/React.createElement("input", {
          type: "number",
          id: "".concat(question.question_key, "-number-input-").concat(questionIndex),
          className: "input-base number-input ".concat(question.question_key, "-number-input \n                  ").concat(disabled ? 'disabled' : ''),
          value: value !== null ? value : '',
          placeholder: question.question_key.indexOf('year') ? new Date().getFullYear() : 'Type here...',
          onChange: function onChange(v) {
            return handleInputChange(v.target.value, answer.column_name, questionIndex);
          },
          disabled: disabled
        })));
      }
      break;
    case 'date':
      return /*#__PURE__*/React.createElement(Question, {
        title: question.question_text,
        className: "".concat(question.question_type, " ").concat(question.style),
        subtext: question.subtext,
        onboardingQuestionnaire: onboardingQuestionnaire,
        questionKey: question.question_key
      }, /*#__PURE__*/React.createElement("label", {
        className: "g-row--always",
        htmlFor: "calendar-".concat(question.question_key)
      }, /*#__PURE__*/React.createElement(DatePicker, {
        selected: value ? moment(value).toDate() : null,
        onChange: function onChange(val) {
          return handleInputChange(val, answer.column_name, questionIndex);
        },
        allowSameDay: true,
        className: "form-control calendar-".concat(question.question_key),
        id: "calendar-".concat(question.question_key, "-").concat(questionIndex),
        value: value ? moment(value).toDate() : moment().toDate(),
        dateFormat: "MM/dd/yyyy",
        placeholderText: "Click to select a date",
        disabled: disabled
      }), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-calendar"
      })));
    case 'year':
      return /*#__PURE__*/React.createElement(Question, {
        title: question.question_text,
        className: "".concat(question.question_type, " ").concat(question.style),
        subtext: question.subtext,
        onboardingQuestionnaire: onboardingQuestionnaire,
        questionKey: question.question_key
      }, /*#__PURE__*/React.createElement(Select, {
        components: dropdownStyle,
        className: "".concat(question.question_type, " ").concat(question.style, " ").concat(question.question_key),
        classNamePrefix: classNamePrefix,
        placeholder: "Select",
        options: yearOptions,
        value: setYear(value, yearOptions),
        onChange: function onChange(option) {
          return handleInputChange(option, answer.column_name, questionIndex);
        },
        isDisabled: disabled
      }));
    default:
      return null;
  }
  return null;
};
var renderErrorMessage = function renderErrorMessage(errors) {
  var length = errors.length;
  return /*#__PURE__*/React.createElement("div", {
    className: "error-message"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-exclamation-triangle"
  }), errors.length > 0 && "Please enter ".concat(errors.slice(0, length - 1).join(', '), " ").concat(length > 1 ? 'and' : '', " ").concat(errors.slice(-1), ". "));
};
function Form(_ref) {
  var questions = _ref.questions,
    answers = _ref.answers,
    index = _ref.index,
    handleInputChange = _ref.handleInputChange,
    handleDelete = _ref.handleDelete,
    errors = _ref.errors,
    disabled = _ref.disabled,
    onboardingQuestionnaire = _ref.onboardingQuestionnaire,
    questionKey = _ref.questionKey,
    formCount = _ref.formCount;
  var className = onboardingQuestionnaire ? "onboarding-".concat(questionKey) : '';
  return /*#__PURE__*/React.createElement(Row, {
    className: "group-parent-form ".concat(className)
  }, /*#__PURE__*/React.createElement(Col, {
    xs: onboardingQuestionnaire ? 12 : 11
  }, /*#__PURE__*/React.createElement(Row, null, errors.length > 0 && renderErrorMessage(errors), questions.map(function (question) {
    return /*#__PURE__*/React.createElement(Col, {
      xs: ['number', 'year'].includes(question.question_type) ? 6 : 12,
      className: "".concat(question.question_type)
    }, renderQuestion(question, answers, handleInputChange, index, errors, disabled, onboardingQuestionnaire));
  }))), /*#__PURE__*/React.createElement(Col, {
    xs: onboardingQuestionnaire ? 12 : 1,
    className: "".concat(onboardingQuestionnaire ? 'text-right' : '')
  }, formCount > 0 && /*#__PURE__*/React.createElement("div", {
    className: "delete-grouping"
  }, /*#__PURE__*/React.createElement("a", {
    role: "button",
    tabIndex: 0,
    type: "button",
    id: "delete-grouping",
    className: disabled ? 'disabled' : '',
    onClick: disabled ? null : function () {
      return handleDelete(index);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-trash-alt"
  })))));
}
Form.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.shape({})),
  answers: PropTypes.arrayOf(PropTypes.shape({})),
  index: PropTypes.number.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(PropTypes.shape({})),
  disabled: PropTypes.bool,
  onboardingQuestionnaire: PropTypes.bool,
  questionKey: PropTypes.string.isRequired,
  formCount: PropTypes.number
};
Form.defaultProps = {
  disabled: false,
  onboardingQuestionnaire: false,
  formCount: 0
};
export default Form;